import { SRTBlock } from '../types';

// Helper: Convert SRT timestamp (00:00:00,000) to milliseconds
export const timeToMs = (timeString: string): number => {
  const parts = timeString.split(':');
  const secondsParts = parts[2].split(',');
  
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseInt(secondsParts[0], 10);
  const milliseconds = parseInt(secondsParts[1], 10);
  
  return (hours * 3600000) + (minutes * 60000) + (seconds * 1000) + milliseconds;
};

// Helper: Convert milliseconds to SRT timestamp (00:00:00,000)
export const msToTime = (duration: number): string => {
  const milliseconds = Math.floor((duration % 1000));
  let seconds = Math.floor((duration / 1000) % 60);
  let minutes = Math.floor((duration / (1000 * 60)) % 60);
  let hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  const h = (hours < 10) ? "0" + hours : hours;
  const m = (minutes < 10) ? "0" + minutes : minutes;
  const s = (seconds < 10) ? "0" + seconds : seconds;
  const ms = (milliseconds < 10) ? "00" + milliseconds : (milliseconds < 100 ? "0" + milliseconds : milliseconds);

  return `${h}:${m}:${s},${ms}`;
};

export const parseSRT = (content: string): SRTBlock[] => {
  // Normalize line endings
  const normalized = content.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const blocks = normalized.split('\n\n');
  
  const parsedBlocks: SRTBlock[] = [];
  
  blocks.forEach((block) => {
    const lines = block.split('\n').filter(line => line.trim() !== '');
    if (lines.length >= 3) {
      // Basic SRT structure: 
      // 1
      // 00:00:01,000 --> 00:00:04,000
      // Text line 1
      // Text line 2
      
      const id = parseInt(lines[0], 10);
      const timeLine = lines[1];
      const timeMatch = timeLine.match(/(\d{2}:\d{2}:\d{2},\d{3}) --> (\d{2}:\d{2}:\d{2},\d{3})/);
      
      if (!isNaN(id) && timeMatch) {
        // Join remaining lines as text
        const text = lines.slice(2).join('\n');
        parsedBlocks.push({
          id,
          startTime: timeMatch[1],
          endTime: timeMatch[2],
          text: text, // Initially, translated text is same as original until processed
          originalText: text
        });
      }
    }
  });

  return parsedBlocks;
};

export const buildSRT = (blocks: SRTBlock[]): string => {
  return blocks.map(block => {
    return `${block.id}\n${block.startTime} --> ${block.endTime}\n${block.text}\n`;
  }).join('\n');
};

export const downloadFile = (filename: string, content: string) => {
  const element = document.createElement('a');
  const file = new Blob([content], {type: 'text/plain'});
  element.href = URL.createObjectURL(file);
  element.download = filename;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};